import { ApiServiceBase } from '../../../base/api-service-base';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Observable } from 'rxjs';
import { MediaHashTagModel } from 'src/app/core/models/reference-model/reference-media-model';

@Injectable({
  providedIn: 'root'
})
export class MediaHashTagService extends ApiServiceBase {
  private readonly REFERENCE_PATH = "/media"
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {
    super(httpClient, authService);
  }

  public getByOrganisation(): Observable<MediaHashTagModel[]> {
    return this.httpGet<any>(this.REFERENCE_PATH + "/mediahashtag/organisation", null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }

  public getAll(): Observable<MediaHashTagModel[]> {
    return this.httpGet<any>(this.REFERENCE_PATH + "/mediahashtag", null)
      .pipe(
        map(response => {
          return response.body;
        })
      );
  }

}